import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from '@angular/router';
import { CoreLanguageService } from '../../services/language.service';
import { WebShopService } from '../../services/webShop.service';
import { BottomSheetHelperService } from '../../services/bottomSheetHelper.service';
import { SecureCheckDialogComponent, WarningdialogComponent, BasketPayConfirmDialogComponent, BasketPayOptionsDialogComponent, BasketPayOptionsDialogModaldata } from '../../modalDialogs';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { InternationalisationService } from '../../forked/angular-internationalisation';
import { CoreLogService } from '../../services/log.service';
import { OverlaySpinnerService } from '../overlayspinner/overlaySpiner.service';
import { ServiceCallService } from '../serviceCall/serviceCall.service';
import { InHauseServiceSelectorService } from '../inHauseServiceSelector/inHauseServiceSelector.service';
import { InHouseOrder, ServiceCallDataModel } from '../../shared/models';
import { InHouseOrderService } from '../../services/inHouseOrder.service';
import { IGroupInfo } from '../groupOrderOverview/groupOrderOverview.facade';
import { GroupOrderServiceSelectorService } from './groupOrderServiceSelector.service';
import { snackBarMessageKey, SnackBarService } from '../../services/snackBar.service';
import { OrderStatus, OrderType, req_Order } from '../../services/IInHouseOrderService';
import { SnackBarMessageType } from '../../shared/contentTypes';
import { req_ServiceCall, ServiceCallStatus, } from "../../services/IInHouseOrderService";

@Component({
  selector: 'groupOrderServiceSelector',
  templateUrl: './groupOrderServiceSelector.component.html',
  styleUrls: ['./groupOrderServiceSelector.component.scss'],
  providers: [ServiceCallService, OverlaySpinnerService, InHauseServiceSelectorService, GroupOrderServiceSelectorService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("serviceButtonEntering", [
      transition("false => true", [
        query(".animate", [
          style({ transform: "scale(0)" }),
          stagger(100, [
            animate("400ms ease-out", style({ transform: "scale(1.1)" })),
            animate("100ms ease-in-out", style({ transform: "scale(1)" }))
          ])
        ])
      ])
    ]),
  ]
})
export class GroupOrderServiceSelectorComponent implements OnInit, OnDestroy {
  public isLoaded: boolean = false;
  private _langSubscriber: Subscription;
  private _groupDataChangedSubscriber: Subscription;
  private _WebshopSettingsInHouseOrderSubscriber: Subscription;
  private _serviceCallsSubscriber: Subscription;
  private _hasOpenItemsSubscriber: Subscription;

  /** InHouse hat auch eine zahlungsart auf dem Server */
  public hasPaymentOnServer: boolean = false;
  /** InHouse hat eine einstellung ob bei bezahlung gezaht werden muss oder später */
  public orderWithoutPayment: boolean = false;

  public useBrowserHistory: boolean = true;
  public isSmallView: boolean = false;

  public group_basket_price$: Observable<number>;
  public group_basket_count$: Observable<number>;
  public readyForPickUpCount$: Observable<number>; //Zahl des roten Kreises (ready for Pick up)
  public GroupInfo$: Observable<IGroupInfo>;
  public has_open_items$: Observable<boolean>;

  public sendGroupOrderButton: string = ""; // todo warum nicht einfach gebunden?

  constructor(private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _location: Location
    , private _webShopService: WebShopService
    , private _internationalisationService: InternationalisationService
    , private _coreLanguageService: CoreLanguageService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _inHouseOrderService: InHouseOrderService
    , private _inHauseServiceSelectorService: InHauseServiceSelectorService
    , private _groupOrderServiceSelectorService: GroupOrderServiceSelectorService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _snackBarService: SnackBarService
  ) { }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber)
      me._langSubscriber.unsubscribe();
    if (me._WebshopSettingsInHouseOrderSubscriber)
      me._WebshopSettingsInHouseOrderSubscriber.unsubscribe();
    if (me._groupDataChangedSubscriber)
      me._groupDataChangedSubscriber.unsubscribe();
    if (me._serviceCallsSubscriber)
      me._serviceCallsSubscriber.unsubscribe();
    if (me._hasOpenItemsSubscriber)
      me._hasOpenItemsSubscriber.unsubscribe();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("GroupOrderServiceSelectorComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;

    me.GroupInfo$ = me._groupOrderServiceSelectorService.GroupInfo$;
    me.group_basket_count$ = me._groupOrderServiceSelectorService.group_basket_count$;
    me.group_basket_price$ = me._groupOrderServiceSelectorService.group_basket_price$;
    me.has_open_items$ = me._groupOrderServiceSelectorService.has_open_items$;

    me.readyForPickUpCount$ = me._groupOrderServiceSelectorService.readyForPickUpCount$;

    me.sendGroupOrderButton = me._coreLanguageService.value("phGroupOrder_Landingpage_SendGroupOrder_Btn");
    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.sendGroupOrderButton = me._coreLanguageService.value("phGroupOrder_Landingpage_SendGroupOrder_Btn");
      me.PushChanges();
    });

    me._inHouseOrderService.GetStatus().then((status) => {
      if (!status.has_pos_connection) {
        me.OpenWarningNoConnectionDialog();
        me.leaveTable(); // automatisch Tisch verlassen und zum HomeScreen
        return; // break here
      }

      me._serviceCallsSubscriber = me._inHauseServiceSelectorService.ObserveServiceCallsChanges.subscribe(async () => {
        if (await me.bindServiceCalls())
          me.PushChanges();
      });

      me._WebshopSettingsInHouseOrderSubscriber = me._inHauseServiceSelectorService.ObserveWebshopSettingsInHouseOrderChanges.subscribe(async () => {
        if (await me.bindWebshopSettingsInHouseOrder())
          me.PushChanges();
      });

      Promise.all([me.bindServiceCalls(), me.bindWebshopSettingsInHouseOrder(), me.bindHasPayment()]).then(async (results) => {
        if (!results[0])
          me._coreLogService.error("InHauseServiceSelectorComponent.ngOnInit", "bindServiceCalls fails");
        if (!results[1])
          me._coreLogService.error("InHauseServiceSelectorComponent.ngOnInit", "bindWebshopSettingsInHouseOrder fails");
        if (!results[2])
          me._coreLogService.error("InHauseServiceSelectorComponent.ngOnInit", "bindHasPayment fails");
        me.isLoaded = true;
        me.PushChanges();
      }).catch((error) => {
        me._coreLogService.error("InHauseServiceSelectorComponent.ngOnInit", "Promise.all(catch)", error);
        me.isLoaded = true;
        me.PushChanges(); // eventuell um nichts zu zeichenen?
      });
    }).catch((error) => {
      me._coreLogService.error("InHauseServiceSelectorComponent.ngOnInit", "inHouseOrderService.GetStatus(catch)", error);
      me.leaveTable(); // automatisch Tisch verlassen und zum HomeScreen
    });
  }

  public WebshopSettingsInHouseOrder: InHouseOrder = null;
  /** ermittelt die aktuellen InhOuseOrder Einstellungen */
  private async bindWebshopSettingsInHouseOrder(): Promise<boolean> {
    const me = this;
    try {
      me.WebshopSettingsInHouseOrder = await me._inHauseServiceSelectorService.GetWebshopSettingsInHouseOrder();
      return true;
    } catch (error) {
      me._coreLogService.error("InHauseServiceSelectorComponent.bindServiceCalls", "catch", error);
      return false;
    }
  }

  /** representiert aktuelle ServiceCalls */
  public ServiceCalls: ServiceCallDataModel[] = [];
  /** ermittelt die aktuellen ServiceCalls */
  private async bindServiceCalls(): Promise<boolean> {
    const me = this;
    try {
      me.ServiceCalls = await me._inHauseServiceSelectorService.GetServiceCalls();
      return true;
    } catch (error) {
      me._coreLogService.error("InHauseServiceSelectorComponent.bindServiceCalls", "catch", error);
      return false;
    }
  }

  public get hasServiceCall(): boolean {
    return this.ServiceCalls.length > 0;
  }

  /** bindet hasPaymentOnServer richtig um den PaymentButton anzuzeigen */
  private async bindHasPayment(): Promise<boolean> {
    const me = this;
    try {
      me.hasPaymentOnServer = await me._inHouseOrderService.HasPaymentOnServer();
      me.orderWithoutPayment = await me._inHauseServiceSelectorService.OrderInHouseWithoutPayment();
      return true;
    } catch (error) {
      me._coreLogService.error("InHauseServiceSelectorComponent.bindHasPayment", "catch", error);
      return false;
    }
  }

  public formatCurrency(amount: number): string {
    const me = this;
    return me._webShopService.formatCurrency(amount);
  }

  public GetGroupNameText(groupName: string): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_Landingpage_Title")
      .replace("{groupname}", "\n" + groupName);
  }

  public GetGroupCreatorText(groupCreator: string): string {
    const me = this;
    return me._coreLanguageService.value("phGroupOrder_Landingpage_Creator")
      .replace("{creator}", groupCreator);
  }

  public get overviewButtonTitle(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.my_order_group_label;
    else
      return "";
  }

  public get overviewButtonDescription(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.my_order_group_subtext;
    else
      return "";
  }

  public get orderButtonTitle(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.order_label;
    else
      return "";
  }

  public get orderButtonDescription(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.order_subtext;
    else
      return "";
  }

  public get payButtonTitle(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.pay_label;
    else
      return "";
  }

  public get payButtonDescription(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.pay_subtext;
    else
      return "";
  }

  public get serviceCallButtonTitle(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.service_call_label;
    else
      return "";
  }

  public get serviceCallButtonDescription(): string {
    const me = this;
    if (me.WebshopSettingsInHouseOrder && me.WebshopSettingsInHouseOrder.landing_page)
      return me.WebshopSettingsInHouseOrder.landing_page.service_call_subtext;
    else
      return "";
  }

  public navigateToGroupOverview() {
    const me = this;
    me._router.navigate(["/groupOrderOverview"]);
  }

  /** Navigate to Menugroup */
  public async navigateToMenuGroup() {
    const me = this;
    me._router.navigate(["/menugroup"]);
  }

  public navigateToPayment() {
    const me = this;
    let has_open_items = false;
    me.has_open_items$.pipe(take(1)).subscribe(value => has_open_items = value).unsubscribe();

    if (has_open_items && me.orderWithoutPayment && me.hasPaymentOnServer) {
      // todo hier könnte auch der gruppen warenkorb geprüft werden
      if (me._webShopService.getShippingCartItems().length > 0) {
        //Dialog zur warnung das noch artikel im basket sind
        const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
          data: {
            title: "phInHouse_ItemsInBasket_Title",
            description: "phInHouse_ItemsInBasket_Description",
            buttonTextAccept: "phInHouse_Accept_Btn",
            buttonTextDeny: "phInHouse_Cancel_Btn",
            icon: "shop-icons.svg#ya-hypersoft-achtung",
          },
          panelClass: "mat-bottom-sheet-container-medium"
        });
        dialog.afterDismissed().subscribe((accepted) => {
          if (accepted) {
            // wenn tisch ausbezahlt wird, werden die BasketItems gelöscht
            // clean up basket remote and local
            me._router.navigate(["/inHausePayment"]);
          } // else keep in place
        });
      } else {
        if (me._webShopService.isPayAtWaiterAvailable) {
          const bottomSheetRef = me._bottomSheetHelperService.open(
            BasketPayOptionsDialogComponent,
            {
              panelClass: "mat-bottom-sheet-container-medium",
            }
          );
          bottomSheetRef.afterDismissed().subscribe((result: boolean) => {
            if (result) {
              me._inHouseOrderService.GetTable(null).then((table) => {
                me._overlaySpinnerService.HideLayoutSpinner();
                const dialogData: BasketPayOptionsDialogModaldata = {
                  posTableNumber: table.posTable.tableNumber,
                  groupName: table.posTable.groupName,
                  tableNumber: table.posTable.tableNumber,
                }
                me._bottomSheetHelperService.open(
                  BasketPayConfirmDialogComponent,
                  {
                    data: dialogData,
                    panelClass: "mat-bottom-sheet-container--full-height",
                  }
                );
              }).catch((error) => {
                me._overlaySpinnerService.HideLayoutSpinner();
                me._snackBarService.ShowErrorMessageFailed(34);
                me._coreLogService.error(
                  "GroupOrderServiceSelectorComponent.navigateToPayment",
                  "_inHouseOrderService.GetTable catch",
                  error
                );
              });
            }
            me._overlaySpinnerService.HideLayoutSpinner();
          });
        } else {
          me._router.navigate(["/inHausePayment"]);
        }
      }
    } else {
      me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
        data: {
          title: "phInHouseService_NoOrderYet_Title",
          description: "phGroupOrder_NoOrderYet_Description",
          buttonTextAccept: "phGlobal_Return",
          icon: "shop-icons.svg#ya-hypersoft-achtung",
        },
        panelClass: "mat-bottom-sheet-container-medium"
      });
    }
  }

  /** Warning dialog: No connection to the restaurant */
  private OpenWarningNoConnectionDialog() {
    const me = this;
    me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phInHouse_NoConnection_Title"
        , content: "phInHouse_NoConnection_Description"
        , btnLabel: "phInHouse_Continue_Btn"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
  }

  /** Navigate to Service Call */
  public navigateToServiceCall() {
    const me = this;
    me._router.navigate(["/servicecall"]);
  }

  public closeGroupOrderingAsync() {
    const me = this;
    /**
     * User hat alles bezahlt -> Tisch verlassen
     * 
     * User hat noch bestellungen, offene Zahlungen/Artikel -> Dialog
     */
    let has_open_items = false;
    me.has_open_items$.pipe(take(1)).subscribe(value => has_open_items = value).unsubscribe();
    let group_basket_count = 0;
    me.group_basket_count$.pipe(take(1)).subscribe(value => group_basket_count = value).unsubscribe();

    if (!has_open_items && me._webShopService.getShippingCartItems().length == 0 && group_basket_count == 0) {
      me.leaveTable();
    } else {
      // todo auslagern, wird auch in webshop service verwendet
      const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
        data: {
          title: "phGroupOrder_LeaveTable_Dialog_Title",
          description: "phGroupOrder_LeaveTable_Dialog_Content",
          buttonTextAccept: "phGlobal_Return",
          buttonTextDeny: "phGroupOrder_LeaveTable_Dialog_Button",
          icon: "shop-icons.svg#ya-hypersoft-achtung",
        },
        panelClass: "mat-bottom-sheet-container-medium"
      });
      dialog.afterDismissed().subscribe((accepted) => {
        //leaveTable only if it is false, click outside of Dialog === undefined
        if (accepted === false) {
          me.leaveTable();
        }
      });
    }
  }

  /**send Group Order */
  public sendGroupOrder() {
    const me = this;
    const dialog = me._bottomSheetHelperService.open(SecureCheckDialogComponent, {
      data: {
        title: "phGroupOrder_SendOrderDialog_Title",
        description: "phGroupOrder_SendOrderDialog_Description",
        buttonTextAccept: "phGroupOrder_SendOrderDialog_AcceptBtn",
        buttonTextDeny: "phGlobal_Return",
        icon: "shop-icons.svg#ya-hypersoft-achtung",
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    dialog.afterDismissed().subscribe((result: any) => {
      if (result) {
        const request: req_Order = {
          order_type: OrderType.GroupBasket,
        };
        me._overlaySpinnerService.ShowLayoutSpinner();
        me._inHouseOrderService.Order(request).then((response) => {
          me._overlaySpinnerService.HideLayoutSpinner();
          if (response.status === OrderStatus.Okay) {
            me._webShopService.clearItems(); // items from basket to table
            me._router.navigate(["/inHauseOrderConfirm"]);
          } else {
            me._coreLogService.error("WebshopService._orderInhouse", "Order status not Okay", response.status);
            me._snackBarService.ShowErrorMessageFailed(35);
          }
        }).catch((error) => {
          me._overlaySpinnerService.HideLayoutSpinner();
          me._coreLogService.error("WebshopService._orderInhouse", "Order catch", error);
          me._snackBarService.ShowErrorMessageFailed(36);
        });
      } //else nothing
    })
  }

  /** verläst tisch und beendet die offene verbindung */
  private async leaveTable(): Promise<void> {
    const me = this;
    me._inHouseOrderService.leaveTable(false);
  }

  /**If small view,navigate back by swiping from left to right.*/
  public swiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }
  /** Navigate back*/
  public navigateBack() {
    const me = this;
    if (me.useBrowserHistory) {
      me._location.back();
    } else {
      me._router.navigate(["/menuservice"], { replaceUrl: true });
    }
  }

}